import { strongBlue } from "../../../config/ColorObj";

export const ProductDetailsIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" stroke={strongBlue} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7" stroke={strongBlue} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 12V16M10 14H14" stroke={strongBlue} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

export const TotalProductsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="2" y="3" width="8" height="8" rx="1.5" stroke={strongBlue} strokeWidth="1.8" />
        <rect x="14" y="3" width="8" height="8" rx="1.5" stroke={strongBlue} strokeWidth="1.8" />
        <rect x="2" y="13" width="8" height="8" rx="1.5" stroke={strongBlue} strokeWidth="1.8" />
        <rect x="14" y="13" width="8" height="8" rx="1.5" stroke={strongBlue} strokeWidth="1.8" />
    </svg>
);

export const TotalQtyIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M3 3H5L5.4 5M5.4 5H21L17 13H7M5.4 5L7 13M7 13L5.3 15H17M17 18C17 18.6 17.4 19 18 19C18.6 19 19 18.6 19 18C19 17.4 18.6 17 18 17C17.4 17 17 17.4 17 18ZM7 18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18C9 17.4 8.6 17 8 17C7.4 17 7 17.4 7 18Z" stroke={strongBlue} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const TopProductIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke={strongBlue} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
